import { render, staticRenderFns } from "./WithoutMenu.vue?vue&type=template&id=88a9a3dc&"
import script from "./WithoutMenu.vue?vue&type=script&lang=js&"
export * from "./WithoutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports